<template>
    <v-list dense flat data-testid="menu-items" class="pa-0 mt-1">
        <v-list-item
            v-for="menu in getMenuItems"
            :dense="$vuetify.breakpoint.mdAndUp"
            light
            :href="menu.href"
            :to="menu.to"
            :target="menu.target"
            :class="menuListClasses"
            class="py-2"
            active-class="top-menu-active"
            tabindex="-1"
            :key="menu.title"
            @click="closeMobileDialogMenu"
        >
            <template v-if="menu.name !== 'locale'">
                <v-list-item-content :class="menu.name">
                    <v-list-item-title :class="menuTitleClasses">
                        <span class="menu-text">
                            {{ menu.title }}
                        </span>
                        <v-icon v-if="menu.icon" size="15" class="ml-2" color="black">
                            {{ menu.icon }}
                        </v-icon>
                    </v-list-item-title>
                </v-list-item-content>

                <v-list-item-action
                    v-if="$vuetify.breakpoint.mdAndUp"
                    class="mx-1 px-1 my-0 separator"
                >
                    |
                </v-list-item-action>
            </template>
            <template v-if="menu.name === 'locale'">
                <v-row>
                    <v-col class="ma-0 pl-0 py-0">
                        <v-btn
                            depressed
                            data-testid="change-locale-button"
                            :class="localeButtonClasses"
                            :aria-label="localeToToggleLabel()"
                            @click="setLocale({ i18n: $i18n, locale:invertLocale})"
                        >
                            <v-icon size="15" class="mr-2" color="black">
                                fa-solid fa-globe
                            </v-icon>
                            <span v-text="localeToToggle()" />
                        </v-btn>
                    </v-col>
                </v-row>
            </template>
        </v-list-item>
    </v-list>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { get, map, assign, includes, filter } from 'lodash';
import { inferPortalUrl } from '@/helpers/env';
import { EstablishmentSetting } from '@/enums';

export default {
    name: 'menu-items',
    data() {
        return {
            menuItems: [
                { name: 'join', to: 'join', target: '_self', icon: '' },
                { name: 'faq', href: inferPortalUrl('/questions-reponses'), target: '_blank', icon: '' },
                { name: 'job', to: '', href: 'https://trimoz.freshteam.com/jobs', icon: 'fas fa-external-link-alt', target: '_blank' },
                { name: 'terms', href: inferPortalUrl(this.locale === 'fr' ? '/termes-et-conditions' : '/terms'), icon: '', target: '_blank' },
                { name: 'policy', href: inferPortalUrl(this.locale === 'fr' ? '/confidentialite' : 'privacy'), icon: '', target: '_blank' },
                { name: 'cookiePolicy', href: inferPortalUrl(this.locale === 'fr' ? '/politique-temoins-connexion' : 'cookie-policy'), icon: '', target: '_blank' },
                { name: 'locale', to: '', icon: '', target: '' },
            ],
            menuWeb: ['faq', 'job'],
            iconSize: 15,
        };
    },
    computed: {
        ...mapGetters({
            locale: 'locale',
            invertLocale: 'invertLocale',
            getEstablishment: 'establishment/getEstablishment',
            getEstablishmentSettingById: 'establishment/getEstablishmentSettingById',
        }),
        getMenuItems() {
            const i18n = this.$i18n;
            return map(filter(this.menuItems, (item) => { return this.showMenu(item); }), items => {
                return assign({}, items, { title: i18n.t('header.clicsante.menu.' + items.name) });
            });
        },
        menuListClasses() {
            const className = 'pa-0';
            return this.$vuetify.breakpoint.mdAndUp
                ? `top-menu-list ${className}`
                : `text-center mobile-menu-list py-1 ${className}`;
        },
        menuTitleClasses() {
            const className = 'font-weight-bold';
            return this.$vuetify.breakpoint.mdAndUp
                ? `caption ${className}`
                : `body-1 menu-title-mobile ${className}`;
        },
        localeButtonClasses() {
            const className = 'white font-weight-bold locale-toggle my-0';
            return this.$vuetify.breakpoint.mdAndUp
                ? `caption ${className}`
                : `body-1 menu-button-mobile ${className}`;
        },
    },
    methods: {
        ...mapActions({
            setLocale: 'setLocale',
        }),
        ...mapMutations({
            setOpenMobileDialogMenu: 'mobileDialogMenu/SET_IS_OPEN',
        }),
        localeToToggle() {
            return this.locale === 'fr' ? 'EN' : 'FR';
        },
        localeToToggleLabel() {
            return this.locale === 'fr' ? 'Switch language to english' : 'Changer la langue en français';
        },
        showMenu(menu) {
            if (menu.name === 'locale') {
                return true;
            }
            if (menu.name === 'join') {
                return !!(get(this.getEstablishment, 'email', false) && this.getEstablishmentSettingById(EstablishmentSetting.SHOW_CONTACT_US_PUBLIC_PAGE));
            }
            if (this.$vuetify.breakpoint.mdAndUp && includes(this.menuWeb, menu.name)) {
                return true;
            }
            if (this.$vuetify.breakpoint.smAndDown) {
                return true;
            }
            return false;
        },
        closeMobileDialogMenu() {
            if (this.$vuetify.breakpoint.smAndDown) {
                this.setOpenMobileDialogMenu(false);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables';
.top-menu-list::v-deep {
    float: left;
}

.top-menu-list::v-deep .v-ripple__container, .mobile-menu-list::v-deep .v-ripple__container  {
    display:none !important;
}

.top-menu-active {
    text-decoration: underline !important;
    text-decoration-color: $cs-color-secondary;
}

.theme--light.v-list-item--active:before, .theme--light.v-list-item--active:hover:before, .theme--light.v-list-item:focus:before {
    opacity: 0;
}

.separator {
    min-width: 12px;
}

.locale-toggle {
    margin-left: -5px;
    margin-top: 5px;
}

.menu-title-mobile {
    text-transform: uppercase;
    white-space: normal;
}
.policy div {
    font-size: 95% !important;
    line-height: 140% !important;
}
.menu-text {
    font-size: 1rem !important
}
</style>
